import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { postApi } from "../../api/api_instance";
import { useNavigate, useParams } from "react-router-dom";
import { API_URLS } from "../../api/apiUrls";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";

export const SessionLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useParams();
  const [popup, setPopup] = useState(null);

  const handleValidateSwitchToken = async (token) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.VALIDATE_SWITCH_TOKEN,
        data: { token },
      });

      if (response.success) {
        setPopup({
          type: "success",
          title: "Login Successful",
          message: response.message || "You are now logged in!",
        });

        // wait 2s → then navigate
        setTimeout(() => {
          setPopup(null);
          navigate("/dashboard");
        }, 2000);
      } else {
        setPopup({
          type: "error",
          title: "Login Failed",
          message: response.message || "Invalid switch token.",
        });

        // wait 2s → then navigate
        setTimeout(() => {
          setPopup(null);
          navigate("/login");
        }, 2000);
      }
    } catch (error) {
      setPopup({
        type: "error",
        title: "Error",
        message: "Login failed. Please check your credentials and try again.",
      });

      setTimeout(() => {
        setPopup(null);
        navigate("/login");
      }, 2000);
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    handleValidateSwitchToken(token);
  }, [token]);

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      <div className="lg:w-2/5 w-full flex flex-col items-center justify-center p-6 lg:p-12 bg-white">
        <div>
          <h4 className="text-xl font-semibold">
            Please wait, switching application...
          </h4>
        </div>
      </div>

      {/* ✅ Popup overlay */}
      {popup && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-40 z-50">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
          />
        </div>
      )}
    </div>
  );
};
